import React from 'react';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import StyleSheet, { colorPalette } from 'styles'
import { flatten } from 'utils'
import { darkTheme } from 'styles'
import { MuiThemeProvider } from '@material-ui/core/styles'

export function CenteredCard(props) {
  const { className } = props
  const classes = className ? flatten([className]) : []
  const centerStyles = {}
  if(props.centerVertically)   centerStyles.justifyContent = 'center'
  if(props.centerHorizontally) centerStyles.alignItems = 'center'
  return (
    <MuiThemeProvider theme={darkTheme}>
      <div className={styles.flex} style={centerStyles}>
        <Card className={[styles.card, ...classes].join(' ')} style={props.style}>
          {props.children}
        </Card>
        <Typography className={styles.link}>
          {props.navBeneath}
        </Typography>
      </div>
    </MuiThemeProvider>
  );
}

CenteredCard.defaultProps = {
  centerVertically: true,
  centerHorizontally: true
}
const styles = StyleSheet({
  card: {
    minWidth: 265,
    background: colorPalette.primary[1].hex(),
    color: '#FFF',
    maxWidth: 400
  },
  flex: {
    padding: 10,
    display: 'flex',
    alignSelf: 'stretch',
    flexDirection: 'column',
    background: colorPalette.primary[1].hex(),
    position: 'relative',
    overflowY: 'auto',
    flex: 1,
    '@media(max-width: 600px)':{
      background: '#1B3044',
      justifyContent: 'flex-start',
    }
  },
  link: {
    flex: '0 auto',
    marginTop: 25
  }
});
